// extracted by mini-css-extract-plugin
export var gridImgTextContainer = "pages-module--gridImgTextContainer--JjTrk";
export var hero = "pages-module--hero--S304A";
export var heroContent = "pages-module--heroContent--lXcQ8";
export var heroImg = "pages-module--heroImg--GhY2T";
export var pageMainContent = "pages-module--pageMainContent--oZaFR";
export var smallWrapper = "pages-module--smallWrapper--4bvPJ";
export var testimonialsPageWrapper = "pages-module--testimonialsPageWrapper--DPXaP";
export var textStyle = "pages-module--textStyle--B694P";